import React, { useEffect, useState } from "react";
import ProposalList from "../../../components/proposal";
import {
    proposerCorrespondenceAddConstants,
    proposerPermanetAddConstants,
    proposerPersonalConstants,
    propserEmploymentConstants,
} from "../../../constans/proposerConstant";

const PropserDetails = ({ proposerData, eligibility }) => {
    const [personalDetailsSection, setPersonalDetailsSection] = useState(
        JSON.parse(JSON.stringify(proposerPersonalConstants))
    );
    const [epmploymentDetailsSection, setEpmploymentDetailsSection] = useState(
        JSON.parse(JSON.stringify(propserEmploymentConstants))
    );
    const [permanentAddressSection, setPermanentAddressSection] = useState(
        JSON.parse(JSON.stringify(proposerPermanetAddConstants))
    );
    const [correspondenceAddressSection, setcorrespondenceAddressSection] =
        useState(JSON.parse(JSON.stringify(proposerCorrespondenceAddConstants)));

    useEffect(() => {
        let section1 = personalDetailsSection && personalDetailsSection.map((item) => {
            if (item.key === "fullname") {
                const firstName = proposerData.personalDetails?.firstName;
                const lastName = proposerData.personalDetails?.lastName;
                item.value = [firstName, lastName].filter(Boolean).join(" ").trim();
            } else if (item.key === "identityType" || item.key === "identityNumber") {
                item.value = proposerData.identityDetail && proposerData.identityDetail[item.key];
            } else if (item.key === "residentialStatus") {
                item.value = proposerData.nationalityDetail && proposerData.nationalityDetail[item.key];
            } else if (
                item.key === "panNumber" &&
                !(proposerData.personalDetails && proposerData.personalDetails.submitForm60)
            ) {
                item.value = proposerData.panDetail && proposerData.panDetail[item.key];
            } else if (item.key === "submitForm60") {
                item.value = proposerData.personalDetails && proposerData.personalDetails.submitForm60 ? "YES" : "NO";
            } else if (item.key === "whatsappOpt") {
                item.value = eligibility && eligibility.whatsappOpt ? "YES" : "NO";
            } else if (
                [
                    "panApplied",
                    "assessedToTax",
                    "otherThanAgriculturalIncome",
                    "agriculturalIncome",
                    "dateOfApplication",
                    "acknowledgementNumber",
                    "reasonForNotHavingPanOrIGNumber",
                    "circleOfLastReturnField",
                ].includes(item.key)
            ) {
                if (!proposerData.personalDetails.submitForm60) {
                    item.show = false;
                } else {
                    item.show = true;
                    if (
                        item.key === "otherThanAgriculturalIncome" ||
                        item.key === "agriculturalIncome"
                    ) {
                        proposerData.panDetail.panApplied
                            ? (item.show = false)
                            : (item.show = true);
                    } else if (
                        item.key === "dateOfApplication" ||
                        item.key === "acknowledgementNumber"
                    ) {
                        !proposerData.panDetail.panApplied
                            ? (item.show = false)
                            : (item.show = true);
                    } else if (
                        item.key === "reasonForNotHavingPanOrIGNumber" ||
                        item.key === "circleOfLastReturnField"
                    ) {
                        !proposerData.panDetail.assessedToTax
                            ? (item.show = false)
                            : (item.show = true);
                    }
                    if (
                        item.key === "agriculturalIncome" ||
                        item.key === "otherThanAgriculturalIncome"
                    ) {
                        item.value = proposerData.personalDetails[item.key];
                    } else if (
                        item.key === "panApplied" ||
                        item.key === "assessedToTax"
                    ) {
                        item.value = proposerData.panDetail[item.key] ? "YES" : "NO";
                    } else {
                        item.value = proposerData.panDetail[item.key];
                    }
                }
            } else {
                item.value = proposerData.personalDetails[item.key];
            }
            return item;
        });
        setPersonalDetailsSection([...section1]);

        let section2 = epmploymentDetailsSection && epmploymentDetailsSection.map((item) => {
            item.value = proposerData.employmentDetails && proposerData.employmentDetails[item.key];
            return item;
        });
        setEpmploymentDetailsSection([...section2]);

        let section3 = permanentAddressSection.map((item) => {
            if (item.key === "alterNateMobNumber") {
                item.value = proposerData.contactDetails && proposerData.contactDetails[item.key];
            } else if (item.key === "sameAsPermanentAddress") {
                item.value = proposerData.contactDetails && proposerData.contactDetails.sameAsPermanentAddress
                    ? "YES"
                    : "NO";
            } else {
                item.value = proposerData.contactDetails &&
                    proposerData.contactDetails.permanentAddress
                    && proposerData.contactDetails.permanentAddress[item.key];
            }
            return item;
        });
        setPermanentAddressSection([...section3]);

        if (!proposerData.contactDetails?.sameAsPermanentAddress) {
            let section4 = correspondenceAddressSection && correspondenceAddressSection.map((item) => {
                item.value =
                    proposerData.contactDetails && proposerData.contactDetails.correspondenceAddress[item.key];
                return item;
            });
            setcorrespondenceAddressSection(section4);
        }
    }, [proposerData]);

    return (
        <div className="main_container">
            <ProposalList
                sectionLabel="Personal Details"
                initialdata={personalDetailsSection}
            />
            <ProposalList
                sectionLabel="Employment Details"
                initialdata={epmploymentDetailsSection}
            />
            <ProposalList
                sectionLabel="Permanent Address"
                initialdata={permanentAddressSection}
            />
            {!proposerData.contactDetails?.sameAsPermanentAddress && (
                <ProposalList
                    sectionLabel="Correspondence Address"
                    initialdata={correspondenceAddressSection}
                />
            )}
        </div>
    );
};

export default PropserDetails;
